<template>
  <router-link v-ripple :to="setting.to" class="cofigBarLink">
    <div class="cofigBarLink_root">
      <div class="cofigBarLink_title">
        <span class="cofigBarLink_title-text"
          >{{ setting.title }}
          <span
            v-if="setting.icon && isAdmin"
            class="cofigBarLink_circle-icon"
          ></span>
        </span>
      </div>
      <div class="cofigBarLink_desc">
        <span>{{ setting.desc }}</span>
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'ConfigBarLink',
  props: {
    setting: {
      type: Object,
      default: () => {},
    },
    active: {
      type: Boolean,
      default: () => false,
    },
    isAdmin: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    handleToggleDetail(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    goTo() {
      this.$router
        .push({
          name: 'settings',
          params: { parent: this.setting.key },
        })
        .catch();
    },
  },
};
</script>

<style lang="scss">
.cofigBarLink {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 9px 5px 10px 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;
  &_circle-icon {
    width: 9px;
    height: 9px;
    background-color: #fcc800;
    border-radius: 50%;
    position: absolute;
    top: 0;
    right: 0;
  }
  &.router-link-active {
    background-color: #f5f5f5;
    background-color: #f3f3f3;
  }

  &_root {
    flex: 1;
  }
  &_title {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    &-text {
      position: relative;
      padding-right: 10px;
    }
  }
  &_desc {
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
  }
}
</style>
